module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_reserve.084c4419.svg";